<!-- <vm-player controls>
  <vm-video cross-origin="true">
    <source [src]="videoUrl" type="video/mp4" />
  </vm-video>
</vm-player> -->
<video #video [style.max-height]="videoMaxHeight" oncontextmenu="return false;" controls (loadeddata)="onPlayClick()" (ended)="onEndVideo()" [poster]="videoPosterUrl" [autoplay]="autoplay" id="myMainVideoPlayer">
	<source [src]="videoUrl" />
</video>
